module.exports = __webpack_public_path__ + "img/jewelry.4f35309.jpg";